// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NotFound_wrapper__1TOYJ","content":"NotFound_content__FTpDu"};